import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Row, Col, Button } from 'react-bootstrap';
import { connect } from '../../reducers/index';
import './styles.css';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import ServiceGrid from '../../components/ServiceGrid';
import OneGraphic from './img/one.svg';
import TwoGraphic from './img/two.svg';
import ThreeGraphic from './img/three.svg';
import AssistGraphic from './img/assist-graphic.svg';
import ReferGraphic from './img/refer-graphic.svg';
import {
  QuickResourcesUTSGStudent,
  QuickResourcesUTSGStaff,
  QuickResourcesUTSCStudent,
  QuickResourcesUTSCStaff,
  QuickResourcesUTMStudent,
  QuickResourcesUTMStaff,
  QuickResourcesOther,
} from './Resources/QuickResources';
import * as _ from 'lodash';
import EmergencyResourcesUTSGStaff from './EmergencyResources/EmergencyResourcesUTSGStaff';
import EmergencyResourcesUTSCStaff from './EmergencyResources/EmergencyResourcesUTSCStaff';
import EmergencyResourcesUTMStaff from './EmergencyResources/EmergencyResourcesUTMStaff';
import EmergencyResourcesUTSGStudent from './EmergencyResources/EmergencyResourcesUTSGStudent';
import EmergencyResourcesUTSCStudent from './EmergencyResources/EmergencyResourcesUTSCStudent';
import EmergencyResourcesUTMStudent from './EmergencyResources/EmergencyResourcesUTMStudent';
import EmergencyResourcesOther from './EmergencyResources/EmergencyResourcesOther';

class IARReferencePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { role: localStorage.getItem('role') || 'NONE' };

    this.printClicked = this.printClicked.bind(this);
  }

  printClicked() {
    window.print();
  }

  render() {
    const { role } = this.props;

    let title;
    let emergencyResources;
    let QuickResources;

    if (role.roleType === 'FACULTY' && role.campusType === 'UTSG') {
      title = '(University of Toronto – St. George Campus Faculty and Staff)';
      emergencyResources = <EmergencyResourcesUTSGStaff />;
      QuickResources = QuickResourcesUTSGStaff;
    } else if (role.roleType === 'STAFF' && role.campusType === 'UTSG') {
      title = '(University of Toronto – St. George Campus Faculty and Staff)';
      emergencyResources = <EmergencyResourcesUTSGStaff />;
      QuickResources = QuickResourcesUTSGStaff;
    } else if (
      (role.roleType === 'STUDENT' && role.campusType === 'UTSG') ||
      (role.roleType === 'OTHER' && role.campusType === 'UTSG')
    ) {
      title = '(University of Toronto – St. George Campus Student)';
      emergencyResources = <EmergencyResourcesUTSGStudent />;
      QuickResources = QuickResourcesUTSGStudent;
    } else if (role.roleType === 'FACULTY' && role.campusType === 'UTSC') {
      title = '(University of Toronto – Scarborough Campus Faculty and Staff)';
      emergencyResources = <EmergencyResourcesUTSCStaff />;
      QuickResources = QuickResourcesUTSCStaff;
    } else if (role.roleType === 'STAFF' && role.campusType === 'UTSC') {
      title = '(University of Toronto – Scarborough Campus Faculty and Staff)';
      emergencyResources = <EmergencyResourcesUTSCStaff />;
      QuickResources = QuickResourcesUTSCStaff;
    } else if (
      (role.roleType === 'STUDENT' && role.campusType === 'UTSC') ||
      (role.roleType === 'OTHER' && role.campusType === 'UTSC')
    ) {
      title = '(University of Toronto – Scarborough Campus Student)';
      emergencyResources = <EmergencyResourcesUTSCStudent />;
      QuickResources = QuickResourcesUTSCStudent;
    } else if (role.roleType === 'FACULTY' && role.campusType === 'UTM') {
      title = 'University of Toronto – Mississauga Campus Staff & Faculty';
      emergencyResources = <EmergencyResourcesUTMStaff />;
      QuickResources = QuickResourcesUTMStaff;
    } else if (role.roleType === 'STAFF' && role.campusType === 'UTM') {
      title = 'University of Toronto – Mississauga Campus Staff & Faculty';
      emergencyResources = <EmergencyResourcesUTMStaff />;
      QuickResources = QuickResourcesUTMStaff;
    } else if (
      (role.roleType === 'STUDENT' && role.campusType === 'UTM') ||
      (role.roleType === 'OTHER' && role.campusType === 'UTM')
    ) {
      title = 'University of Toronto – Mississauga Campus Students';
      emergencyResources = <EmergencyResourcesUTMStudent />;
      QuickResources = QuickResourcesUTMStudent;
    } else if (
      role.campusType === 'OTHER'
    ) {
      title = '';
      emergencyResources = <EmergencyResourcesOther />;
      QuickResources = QuickResourcesOther;
    }

    return (
      <div className="iar-guide">
        <Helmet>
          <title>Quick Resources</title>
        </Helmet>
        <Navigation role={role} />
        <section>
          <div id="maincontent" className="container">
            <Row className="text-center">
              <Col className="buttonCol" xs={12} sm={1} smOffset={9}>
                <Button className="buttonPrint" onClick={this.printClicked}>
                  Print IAR Quick Guide
                </Button>
              </Col>
              <Col xs={10} xsOffset={1}>
                <h1 className="no-bold">
                  <span className="txt-purple bold">I</span>
                  <span className="txt-green bold">A</span>
                  <span className="txt-dkblue bold">R</span>
                  &nbsp;{`Quick Reference Guide ${title}`}
                </h1>
                <p>
                  Identify, Assist, Refer guides you
                  in identifying someone experiencing a mental health challenge,
                  offering assistance, and facilitating help-seeking behaviour.
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container">
            <Row>
              <Col xs={12} md={4} className="col-01">
                <img
                  className="img-block"
                  src={OneGraphic}
                  width="88"
                  alt="One"
                />
                <h2 className="txt-purple text-center">Identify.</h2>
                <p>
                  Being able to identify when someone is experiencing a mental
                  health challenge is an essential first step in getting them
                  connected with the resources they may need. There are a number
                  of indicators (behaviours, thoughts and feelings) that you
                  can recognize.
                </p>
                <h3 className="txt-purple">
                  It’s important to note if these indicators seem:
                </h3>
                <ul>
                  <li>Out of character</li>
                  <li>To occur all of a sudden</li>
                  <li>To occur frequently</li>
                  <li>To persist over time (e.g. multiple days or weeks)</li>
                  <li>To have a significant impact on the individual </li>
                  <li>If it raises specific safety concerns</li>
                </ul>
                <h3 className="txt-purple">
                  Some indicators raise specific safety concerns​. These include:
                </h3>
                <ul>
                  <li>Vague or overt references to harming self or others</li>
                  <li>Vague or overt references to thoughts of suicide</li>
                  <li>
                    Confusion, disorientation, apparent disconnect from reality
                    (written or verbal)
                  </li>
                  <li>
                    Expressions of hopelessness, helplessness, or worthlessness
                    (written or verbal)
                  </li>
                </ul>
                <p>
                  When you’re concerned that there’s a risk to someone’s safety,
                  it’s important to act. <strong>In these urgent situations, a more immediate
                  connection or referral is required</strong>.
                </p>
              </Col>
              <Col xs={12} md={4} className="col-02">
                <img
                  className="img-block"
                  src={TwoGraphic}
                  width="88"
                  alt="Two"
                />
                <h2 className="txt-green text-center">Assist.</h2>
                <p>
                  Once you’ve identified that someone is experiencing a mental health
                  challenge, the next step is to engage them in a conversation to
                  better understand their needs in order to connect them with resources 
	    	  suited to their needs and readiness.
                </p>
                <h3 className="txt-green">
                  You can offer assistance through conversations by incorporating these components:
                </h3>
                <ul>
                  <li>Choose a Place and Time</li>
                  <li>Validate their Feelings</li>
                  <li>Listen actively</li>
                  <li>Don’t promise to keep secrets</li>
                  <li>Avoid giving advice</li>
                  <li>Instill a sense of hope</li>
                </ul>
                <p>
                  <br />
                  <img
                    className="img-block img-responsive"
                    src={AssistGraphic}
                    alt="Help is available"
                  />
                </p>
              </Col>
              <Col xs={12} md={4}>
                <img
                  className="img-block"
                  src={ThreeGraphic}
                  width="88"
                  alt="Three"
                />
                <h2 className="txt-dkblue text-center">Refer.</h2>
                <p>
                  Once you have a better understanding of the challenges the person is experiencing,
                  you can facilitate help-seeking behavior by working with them to navigate the options
                  of resources and services on- and off-campus.
                </p>
                <h3 className="txt-dkblue">To facilitate effective referrals to a set of appropriate resources and services, incorporate these components:</h3>
                <ul>
                  <li>Acknowledge limitations</li>
                  <li>Share resources and services</li>
                  <li>Explain</li>
                  <li>Follow up</li>
                </ul>
                <p>
                  <strong>In urgent situations where there’s concerns about anyone's safety, a more immediate
                  connection or referral is required even when the person you are concerned about is
                  unwilling to access these resources themselves.</strong>
                </p>
                <p>
                  <img
                    className="img-block img-responsive"
                    src={ReferGraphic}
                    alt="Graphic of student looking for help directions"
                  />
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container page-break-before page-break-after">
            <Row>
              <Col xs={10} xsOffset={1}>
                <h2 className="text-center no-bold">Resources</h2>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1}>
                <ServiceGrid resources={QuickResources} />
              </Col>
            </Row>
            {emergencyResources}
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}
IARReferencePage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

IARReferencePage.defaultProps = {
  role: {}
};

const Reference = IARReferencePage;

export default connect.role(Reference);



// WEBPACK FOOTER //
// ./src/containers/IARReference/index.jsx